import { getMACalculator, isFiniteNumber } from "../utils";
import { MAEnvelope as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 50),
    );
    const sourcePath =
      options?.sourcePath ?? defaultOptions.sourcePath ?? "close";
    const movingAverageType =
      options?.movingAverageType || defaultOptions.movingAverageType || "sma";
    const shiftType =
      options?.shiftType ?? defaultOptions.shiftType ?? "percent";
    const shift = Number(options?.shift ?? defaultOptions.shift ?? 5);

    // Get MA calculator using centralized utility
    const maFactory = getMACalculator(movingAverageType);
    const maCalculator = maFactory().options({
      windowSize: period,
      sourcePath,
    });

    const maValues = maCalculator(data);

    const results = new Array(data.length).fill(undefined);

    for (let i = 0; i < data.length; i += 1) {
      const mid = maValues[i];

      if (!isFiniteNumber(mid)) {
        continue;
      }

      let top, bottom;

      if (shiftType === "percent") {
        // Percent mode: MA × (1 ± shift/100)
        const factor = shift / 100;
        top = mid * (1 + factor);
        bottom = mid * (1 - factor);
      } else {
        // Points mode: MA ± shift
        top = mid + shift;
        bottom = mid - shift;
      }

      results[i] = {
        top,
        middle: mid,
        bottom,
      };
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 50),
    );
    return period - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
